export default __webpack_public_path__ + "b37a37aa498da0f2f83f75a73b9a593f.svg";